module.exports = __webpack_public_path__ + "img/组 259.46edea03.png";